import React from 'react';
import { ReactComponent as Download } from '../../assets/images/icons/download-icon.svg';

export default function DownloadIcon(props) {
  return (
    <Download className={`icon ${props.className}`} />
  );
}
